import React from 'react';
import { Col, Row } from '@vertem-core/vertice-ds';
import PropTypes from 'prop-types';

const CategoryWrapper = ({ children }) => {
  return (
    <Col className="col">
      <Row gutter={0}>
        { children }
      </Row>
    </Col>
  );
};
CategoryWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CategoryWrapper;
